export const I18N_ERROR_404_NOT_FOUND = 'error.404_not_found';
export const I18N_ERROR_404_NOT_FOUND_TITLE = `${I18N_ERROR_404_NOT_FOUND}_title`;
export const I18N_ERROR_404_NOT_FOUND_MESSAGE = `${I18N_ERROR_404_NOT_FOUND}_message`;
export const I18N_ERROR_404_NOT_FOUND_BUTTON = `${I18N_ERROR_404_NOT_FOUND}_button`;
export const ERROR_404_BUTTON_LINK = '/';
export const WARNING_ICON = 'warning';
